window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
	  'Coded by %cHoculus srl %con %cShopify %c- %c'+theme.settings.themeName+' %c -> https://www.hoculus.com','color: red; font-weight: bold', 'color: unset', 'color: green', 'color: unset', 'color: blue', 'color: unset; font-weight: bold'
	);
}
// IUBENDA CONFIG
var _iub = _iub || [];
switch(Shopify.locale){
	case 'en':
	_iub.csConfiguration = {"consentOnContinuedBrowsing":true,"cookiePolicyInOtherWindow":true,"whitelabel":false,"lang":"en-GB","siteId":2356223,"cookiePolicyId":92090418, "cookiePolicyUrl":"https://beautiemilano.com/en/pages/privacy", "banner":{ "acceptButtonDisplay":true,"customizeButtonDisplay":true,"position":"float-bottom-center","acceptButtonColor":"black","acceptButtonCaptionColor":"white","customizeButtonColor":"black","customizeButtonCaptionColor":"white","rejectButtonColor":"#0073CE","rejectButtonCaptionColor":"white","textColor":"black","backgroundColor":"white" }};
	break;
	default:
	_iub.csConfiguration = {"consentOnContinuedBrowsing":true,"cookiePolicyInOtherWindow":true,"whitelabel":false,"lang":"it","siteId":2356223,"cookiePolicyId":39467706,"cookiePolicyUrl":"https://beautiemilano.com/pages/privacy", "banner":{ "acceptButtonDisplay":true,"customizeButtonDisplay":true,"position":"float-bottom-center","acceptButtonColor":"black","acceptButtonCaptionColor":"white","customizeButtonColor":"black","customizeButtonCaptionColor":"white","rejectButtonColor":"#0073CE","rejectButtonCaptionColor":"white","textColor":"black","backgroundColor":"white" }};
}
hoculus.domready = function(callback) {
    if (document.readyState == 'complete') callback();
    else document.addEventListener('DOMContentLoaded', callback());
};
hoculus.resize = function(callback){
    window.addEventListener('resize', callback);
}
hoculus.utils = {
	loadVideo: function(element){
		if (element.getBoundingClientRect().width!=0){
			element.innerHTML = '';
			var video = document.createElement('video');
			var img = document.createElement('img');
      		img.src = element.dataset.fallback;
			if (element.dataset.autoplay=='true'){
				video.autoplay=true;
				video.autoplay="autoplay";
			}
			if (element.dataset.mute=='true'){
				video.muted = true;
				video.setAttribute('muted', '');
			}
			if (element.dataset.loop=='true'){
				video.loop=true;
			}
			if (element.dataset.playsinline=='true'){
				video.setAttribute('webkit-playsinline', '');
				video.setAttribute('playsinline', '');
			}
			if (element.dataset.class){
				video.className = element.dataset.class;
				img.className = element.dataset.class;
			}
			video.controls = false;
			var source = document.createElement('source');
			source.src = element.dataset.src;
			source.type = 'video/mp4';
			video.appendChild(source);
			if (video.canPlayType && video.canPlayType('video/mp4').replace(/no/, '')) {
				element.appendChild(video);
				var appended = element.querySelector('video');
				
				appended.play();
	  			if (appended.paused) {
      				element.innerHTML = '';
      				element.appendChild(img);
  				}
			}else if(element.dataset.fallback){
				element.innerHTML = '';
				element.appendChild(img);
			};
		}else{
			element.innerHTML = '';
		}
	},
	customEvent: function(event,element){
		element.dispatchEvent(new CustomEvent(event));
	},
    setCookie: function(name,value,minutes){
        var expires = "";
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    getCookie: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    eraseCookie: function(name) {   
	    document.cookie = name+'=; Max-Age=-99999999;';  
	},
    initCarousels: function(){
		const containers = document.querySelectorAll(".owl-carousel.owl-theme:not(.hoculus-ig-carousel)");
		if(containers.length > 0) {
			hoculus.utils.insertCss(hoculus.themeData.owlCarouselCss);
			hoculus.utils.insertCss(hoculus.themeData.owlCarouselThemeCss);
			$.getScript(hoculus.themeData.owlCarouselJs,function(){
				containers.forEach((element) => {
					var settings = JSON.parse($(element).attr('data-hoculus-carousel'));
					var carousel = $(element).owlCarousel(settings);
					if (settings.pauseOnInt){
						carousel.on('drag.owl.carousel', function() {
							carousel.trigger('stop.owl.autoplay');
						});
						carousel.find('[aria-label="Next"], [aria-label="Previous"]').on('click',function(){
							carousel.trigger('stop.owl.autoplay');
						});
					}
					carousel.on('refreshed.owl.carousel', function() {
						hoculus.addToCartBtn();
						hoculus.translateProductTags();
					});
				});
				hoculus.addToCartBtn();
				hoculus.carouselLoaded = true;
			});
		}
	},
	insertCss: function(css){
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', css);
        document.head.appendChild(link);
    },
    slideToggle: function(){
		$('.hoculus-slide-toggle-btn').click(function(){
			$(this).toggleClass('hoculus-rotate-90');
			$(this).parents('.hoculus-slide-toggle').find('.hoculus-slide-toggle-content').slideToggle(600);
		})
	},
	discountCheck: function(){
		var parent = this;
	    this.getDiscountName = function(cname) {
	      var name = cname + "=";
	      var decodedCookie = decodeURIComponent(document.cookie);
	      var ca = decodedCookie.split(';');
	      for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	          c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	          return c.substring(name.length, c.length);
	        }
	      }
	      return "";
	    }
	    var url = 'https://analytics.hoculus.com/api/discount_codes_v2.php?store=';
	    var store = 'beautiemilano.com';
	    var discount = parent.getDiscountName('discount_code');
	    if(discount!=''){
		    $.ajax({url: url+store+'&code='+discount}).done(function(result){
		      	if(result){
		      	  	
		      	}
		    });
	    }
	},
	addDiscount: function(discount){
        return new Promise(function(resolve,reject){
            $.ajax({
                url: "/discount/"+discount,
                complete: function (data) {
                    resolve(data);
                }
            })
        });
    },
    lockWidth: function($element){
    	$element.css('min-width',$element.outerWidth());
    },
    unlockWidth: function($element){
    	$element.css('min-width','');
    },
    getScript: function(source,callback){
	    var script = document.createElement('script');
	    var prior = document.getElementsByTagName('script')[0];
	    script.defer = 1;

	    script.onload = script.onreadystatechange = function( _, isAbort ) {
	        if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
	            script.onload = script.onreadystatechange = null;
	            script = undefined;

	            if(!isAbort && callback) setTimeout(callback, 0);
	        }
	    };

	    script.src = source;
	    prior.parentNode.insertBefore(script, prior);
	},
    getMobileOs: function(){
		var isMobile = {
		    Android: function() {return navigator.userAgent.match(/Android/i);},
		    iOS: function() {return navigator.userAgent.match(/iPhone|iPad|iPod/i);},
		    any: function() {return (isMobile.Android() || isMobile.iOS())}
		};
		if (isMobile.Android()) {
		    return 'android'
		}
		if (isMobile.iOS()) {
		    return 'ios'
		}
		if (isMobile.any()) {
		    return 'mobile'
		}
		if (!isMobile.any()) {
		    return 'desktop'
		}
	},
    analyticsEvent: function(category,action,label){
		ga('send', {
		  hitType: 'event',
		  eventCategory: category,
		  eventAction: action,
		  eventLabel: label
		});
	},
	loadHotjar: function(){
		(function(h,o,t,j,a,r){
	        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
	        h._hjSettings={hjid:2344195,hjsv:6};
	        a=o.getElementsByTagName('head')[0];
	        r=o.createElement('script');r.async=1;
	        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
	        a.appendChild(r);
	    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
	},
	onLoad: function(){
		setTimeout(function(){
			hoculus.utils.getScript(hoculus.themeData.jQuery,function(){
				hoculus.discountBanners();
				hoculus.addToCartBtn();
				hoculus.utils.initCarousels();
				hoculus.utils.slideToggle();
				hoculus.lazyVideo();
				hoculus.cardCarousel();
				hoculus.klaviyoMailDiscount();
				hoculus.iubenda();
				hoculus.translateProductTags();
				hoculus.whatsappBtn();
				hoculus.discountBtns();
				//hoculus.utils.loadHotjar();
				hoculus.scriptLoaded = true;
			});
		},2)
	}
}
hoculus.discountBanners = function(trigger = false, fakeDiscount = 'CODICESCONTO'){
	var parent = this;
	this.appendBar = function(banner){
		$('.footer-discount.offer').remove();
		if (theme.hoculus.discountBannerNoAnnouncement){
			$('[data-section-id="hoculus-header"]').find('.announcement-bar').remove();
			$('[data-section-id="hoculus-header"]').prepend(banner);
			$('.hoculus.img-hero').css('height', 'calc(100vh - '+$('#discount-code-banner').outerHeight()+'px)');
		}else{
			$('#HeaderWrapper').prepend(banner);
		}
	}
	this.appendDiscountTag = function(discountCart){
		if ($('#CartDrawer .cart_progress').length > 0){
			$('#CartDrawer .cart_progress').append(discountCart);
		}else{
			$('#CartDrawer .drawer__fixed-header').append(discountCart);
		}
        setTimeout(function(){
        	$(discountCart).toggleClass('visible');
        },5)
	}
	this.discountCartOffer = function(){
    	var discountCart = $('<div class="footer-discount offer appear-animation appear-delay-1">'+theme.hoculus.discountCartOfferTxt+'</div>')
		parent.appendDiscountTag(discountCart);
    	$('.footer-discount.offer').off().on('click',function(){
    		var button = $(this);
    		button.off();
    		hoculus.utils.lockWidth(button);
			button.toggleClass('disabled btn--loading');
    		hoculus.utils.addDiscount(theme.hoculus.discountCartOfferDname).then(function(resp){
    			button.toggleClass('btn--loading');
    			switch(Shopify.locale){
    				case 'en':
    				button.text('✅ Discount code added!');
    				break;
    				default:
    				button.text('✅ Sconto aggiunto con successo');
    			}
    			hoculus.utils.analyticsEvent('Drawer discount','click','cart drawer - '+theme.hoculus.discountCartOfferDname);
    			setTimeout(function(){
    				button.toggleClass('visible');
    				hoculus.discountBanners();
    			},1500)
    		});
    	})
	}
	this.init = function(){
		if ((theme.hoculus.discountBanner || Shopify.designMode)){
		    var discount = hoculus.utils.getCookie('discount_code');
		    var shown = hoculus.utils.getCookie('hoculus_discount_banner');
		    if(discount && !trigger){
		    	var discountCart = $('<div class="footer-discount">'+theme.hoculus.discountCartTxt.replace('{{DISCOUNT}}', '<b>'+discount+'</b>')+'</div>');
				parent.appendDiscountTag(discountCart);
		    	if (!shown){
		    		hoculus.utils.setCookie('hoculus_discount_banner','shown',30);
		    		var banner = '<div id="discount-code-banner" style="padding: 0 20px; background-color:'+theme.hoculus.discountBannerBgColor+'"><p style="color: '+theme.hoculus.discountBannerTxtColor+'; margin: 0px; padding: 15px 0;text-align: center;">'+theme.hoculus.discountBannerTxt.replace('{{DISCOUNT}}', '<b>'+discount+'</b>')+'</p></div>'
		    		parent.appendBar(banner);
		    	}
		    }else if(theme.hoculus.discountCartOfferDname!='' && !Shopify.designMode && !trigger){
		    	parent.discountCartOffer();
		    }else if((Shopify.designMode && theme.hoculus.discountBannerPreview) || trigger){
		    	var discountCart = $('<div class="footer-discount">'+theme.hoculus.discountCartTxt.replace('{{DISCOUNT}}', '<b>'+fakeDiscount+'</b>')+'</div>');
				parent.appendDiscountTag(discountCart);
		        var banner = '<div id="discount-code-banner" style="padding: 0 20px; background-color:'+theme.hoculus.discountBannerBgColor+'"><p style="color: '+theme.hoculus.discountBannerTxtColor+'; margin: 0px; padding: 15px 0;text-align: center;" >'+theme.hoculus.discountBannerTxt.replace('{{DISCOUNT}}', '<b>'+fakeDiscount+'</b>')+'</p></div>'
		        parent.appendBar(banner);
		        if(theme.hoculus.discountCartOfferDname!='' && !trigger){
		        	$('.footer-discount').toggleClass('visible');
		        	parent.discountCartOffer();
		        	setInterval(function(){
		        		$('.footer-discount').toggleClass('visible');
		        	},5000)
		        }
		    }
		}
	}
	this.init();
}
hoculus.cartUpdate = function(subtotal,items){
	this.progressBar = function(subtotal){
		subtotalCurrency = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
		var progressContainer = document.querySelector('#CartDrawerForm .hoculus.cart_progress');
		var progressBar = progressContainer.querySelector('.progress_line_main');
		var progressBarPrice = progressContainer.querySelector('.progress_line_main .progress_line_price');
		var text = progressContainer.querySelector('.cart_progress_text');
		var percentage = Math.round(subtotal/theme.hoculus.progressBarMax);
		progressBar.style.width = percentage+'%';
		progressBarPrice.innerText = subtotalCurrency;
		if (percentage>=100){
			text.innerText = theme.hoculus.progressBarSuccessMessage;
		}else{
			text.innerText = theme.hoculus.progressBarDefaultMessage.replace("[mancante]", theme.Currency.formatMoney((parseInt(theme.hoculus.progressBarMax)*100-parseInt(subtotal)),theme.settings.moneyFormat));
		}
	}
	this.conditionalUpsell = function(items){
		var upsellTriggers = items.querySelectorAll('.cart__item');
		var upsellTriggersData = [];
		if (document.getElementById('cart-upsell-rules')){
			var triggersSettings = JSON.parse(document.getElementById('cart-upsell-rules').textContent);
			var winning_weight = winning_id = toshow = 0;
			var owl = $('#cart-upsell-carousel');
			(async() => {
			    while(!hoculus.carouselLoaded)
			        await new Promise(resolve => setTimeout(resolve, 100));
			    var cartIds = [];
	    		upsellTriggers.forEach(function(e,i){
	    			var id = e.dataset.key.split(':')[0]
	    			cartIds.push(id);
	    			triggersSettings.upsell_triggers.forEach(function(j,k){
	    				if (j.id == id && j.weight > winning_weight) {
	    					winning_weight = j.weight;
	    					winning_id = j.id; 
	    				}
	    			})
	    		})
	    		var triggered = document.querySelectorAll('[data-trigger-product-id="'+winning_id+'"]');
	    		for (var i = owl.data('owl.carousel')._items.length - 1; i >= 0; i--) {
	    			owl.trigger('remove.owl.carousel',[i]);
	    		}
				triggered.forEach(function(e,i){
					if(!cartIds.includes(e.dataset.currentProductId)){
						toshow++;
						owl.trigger('add.owl.carousel',e.outerHTML);
					}
				});
				if(toshow == 0){
					$('#CartDrawer .hoculus-slide-toggle').css( "display", "none");
				}else{
					$('#CartDrawer .hoculus-slide-toggle').css( "display", "block");
					owl.trigger('refresh.owl.carousel');
				}
			})();
		}
	}
	if(theme.hoculus.progressBar){
		this.progressBar(subtotal);
	}
	this.conditionalUpsell(items);
}
hoculus.addToCartBtn = function(){
	$('.btn.hoculus-add-to-cart').off('click').on('click',function(e){
		e.preventDefault();
		var btn = $(this);
		var postData = {
			items:[
				{
					id: btn.attr('data-hoculus-variant-id'),
					quantity: 1
				}
			]
		}
		$.ajax({
	        url: '/cart/add.js',
	        dataType: 'json',
	        cache: false,
	        type: 'post',
	        data: postData,
	        beforeSend: function() {
	          hoculus.utils.lockWidth(btn);
	          btn.toggleClass('disabled btn--loading');
	          $('body').toggleClass('hoculus-disabled')
	        },
	        success: function(itemData) {
	          btn.toggleClass('disabled btn--loading');
	          $('body').toggleClass('hoculus-disabled')
	          hoculus.utils.customEvent('ajaxProduct:added',document);
	          hoculus.utils.customEvent('cart:open',document);
	          if (btn.attr('data-hoculus-click-event')){
	          	var clickData = JSON.parse(btn.attr('data-hoculus-click-event'));
	          	hoculus.utils.analyticsEvent(clickData.category,clickData.action,clickData.label);
	          }
	        },
	        error: function(XMLHttpRequest) {
	          btn.toggleClass('disabled btn--loading');
	          $('body').toggleClass('hoculus-disabled')
	          var response = eval('(' + XMLHttpRequest.responseText + ')');
	          response = response.description;
	          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
	          btn.after(warning);
	        },
	        always: function(){
	        	hoculus.utils.unlockWidth(btn);
	        }
	      });
	})
}
hoculus.paintDrip = function(){
	var parent = this;
	this.init = function(){
		var paintDripContainer = document.getElementById('paintContainer');
		if(paintDripContainer){
			$.getScript(hoculus.themeData.p5Js,function(){
				$.getScript(hoculus.themeData.sketch);
			});
		}
	}
	this.init()
}
hoculus.lazyVideo = function(){
	var lazyVideos = document.querySelectorAll("div[hoculus-lazy-video]");
	if (lazyVideos.length > 0){
		lazyVideos.forEach(function(element,index){
			hoculus.utils.loadVideo(element);
		});
	}
}
hoculus.cardCarousel = function(){
	var parent = this;
	this.alignCards = function(carousel){
		var container = carousel.find('.item-container');
		var item = carousel.find('.item');
		var body = carousel.find('.card-body');
		container.css('height', '100%');
		item.css('width', '200%');
		body.slideDown(0);
	    container.height(container.height());
		item.css('width', '');
		body.slideUp(0);
		carousel.find('.center .card-body').slideDown(0);
	}
	this.init = function(){
		var cardCarousels = document.querySelectorAll(".hoculus.card-carousel");
		if (cardCarousels.length > 0){
			(async() => {
			    while(!hoculus.carouselLoaded)
			        await new Promise(resolve => setTimeout(resolve, 100));
	    		cardCarousels.forEach(function(element,index){
	    			var carousel = $(element).find('.owl-carousel');
	    			parent.alignCards(carousel);
	    			carousel.owlCarousel();
	    			carousel.on('changed.owl.carousel', function(property) {
	    			    var current = property.item.index;
						carousel.find('.card-body').slideUp(300);
						carousel.find('.owl-item').eq(current).find('.item').addClass('w-200');
						setTimeout(function() {
							carousel.find('.owl-item').not(':eq('+ current +')').find('.item').removeClass('w-200');
							carousel.find('.owl-item').eq(current).find('.card-body').slideDown(600);
							carousel.find('.owl-nav').css({"pointer-events":"", "touch-action":""});
						}, 300);
	    			});
	    			carousel.on('resized.owl.carousel', function() {
	    				parent.alignCards(carousel);
	    			});
	    			carousel.on('drag.owl.carousel', function() {
	    				carousel.trigger('stop.owl.autoplay');
	    			});
	    		});
			})();
		}
	}
	this.init();
}
hoculus.deleteDiscountCookies = function(){
	hoculus.utils.eraseCookie('hoculus_discount_banner');
	hoculus.utils.eraseCookie('discount_code');
};
hoculus.cartSubmit = function(){
	$('#CartDrawerForm').submit(function(){
		hoculus.deleteDiscountCookies();
	});
}
hoculus.addCalendar = function(){
	var buttons = document.querySelectorAll("div[data-hoculus-addcalendar]");
	if (buttons.length > 0){
		hoculus.utils.getScript(hoculus.themeData.datebookJs,function(){
			buttons.forEach(function(e,i){
				var settings = JSON.parse(e.dataset.hoculusAddcalendar);
				settings.start = new Date(settings.start);
				settings.end = new Date(settings.end);
				if (settings.mode == 'auto'){
					var device = hoculus.utils.getMobileOs();
				}else{
					var device = settings.mode;
				}
				if (device == 'ios'){
					var ical = new datebook.ICalendar(settings);
					ical.addAlarm({
					    action: 'DISPLAY',
					    trigger: {
					      minutes: 10
					    }
					})
				}else{
					var ical = new datebook.GoogleCalendar(settings);
				}
				e.addEventListener('click',function(){
					hoculus.utils.analyticsEvent('Calendar','download',device);
					if (device == 'ios'){
						ical.download();
					}else{
						var calendarUrl = ical.render();
						window.open(calendarUrl, '_blank');
					}
				})
			})
		});
	}
}
hoculus.countDown = function(){
	var countdown = document.querySelectorAll('[data-hoculus-countdown]');
	if (countdown.length > 0) {
		countdown.forEach(function(e,i){
			var end = new Date(e.dataset.hoculusCountdown);
			var _second = 1000;
			var _minute = _second * 60;
			var _hour = _minute * 60;
			var _day = _hour * 24;
			var timer;
			function showRemaining() {
			    var now = new Date();
			    var distance = end - now;
			    if (distance < 0) {
			        clearInterval(timer);
			        document.getElementById('countdown').innerHTML = 'In corso!';
			        return;
			    }
			    var days = Math.floor(distance / _day);
			    var hours = Math.floor((distance % _day) / _hour);
			    var minutes = Math.floor((distance % _hour) / _minute);
			    var seconds = Math.floor((distance % _minute) / _second);
			    e.innerHTML = days + 'g, ';
			    e.innerHTML += hours + 'o, ';
			    e.innerHTML += minutes + 'm, ';
			    e.innerHTML += seconds + 's';
			}
			timer = setInterval(showRemaining, 1000);
		})
	}
}
hoculus.klaviyoMailDiscount = function(){
	window.addEventListener("klaviyoForms", function(e) { 
	 	if(e.detail.type=='submit' && e.detail.formId == "WepYsW"){
	 		hoculus.utils.addDiscount('LANCIO10').then(function(resp){
	 			setTimeout(function(){
					hoculus.discountBanners();
				},500)
	 		});
	 	};
	});
}
hoculus.closeTabs = function(el){
	var currentId = $(el).attr('aria-controls');
	var parent = $(el).parents('.shopify-section');
	var contents = parent.find('.collapsible-content.is-open:not(#'+currentId+')')
	contents.height(0).removeClass('is-open');
	contents.prev().removeClass('is-open').attr('aria-expanded','false');
}
hoculus.iubenda = function(){
    var loadIubendaBadge = function() {
    	$.getScript('https://cdn.iubenda.com/cs/iubenda_cs.js');
    };
    if (!Shopify.designMode){
      	loadIubendaBadge();
    }
}
hoculus.klaviyoFireEvent = function(){
	var klaviyoIds = ["SfYcGt","WepYsW"];
	window.addEventListener("klaviyoForms", function(e) { 
	 	if(e.detail.type=='submit' && klaviyoIds.includes(e.detail.formId)){
	 		fbq('track', 'Lead');
	 		analyticsEvent('Klaviyo Form','submit',e.detail.formId);
	 	};
	});
}
hoculus.translateProductTags = function(){
	var translations = [
		{	
			'text': 'PIÙ CONVENIENTE',
			'en': 'BEST VALUE'
		}
	]
	var productTags = document.querySelectorAll('.grid-product__tag--custom');
	if (productTags.length > 0) {
		productTags.forEach(function(e,i){
			var index = translations.findIndex(p => p.text == e.innerText);
			if (index >= 0 && translations[index][Shopify.locale]){
				e.innerText = translations[index][Shopify.locale];
			}
		})
	}
}
hoculus.whatsappBtn = function(){
	if(document.querySelector('#whatsapp-icon')){
		$('#whatsapp-icon').on('click',function(e){
			fbq('track', 'Contact');
			hoculus.utils.analyticsEvent('Whatsapp Btn','click');
			setTimeout(function(){
				window.open("https://wa.me/"+$('#whatsapp-icon').data('number')+'?text='+$('#whatsapp-icon').data('text'));
			},200)

		});
		var showing = false;
		$(window).scroll(function() {
		    if ($(this).scrollTop() > document.querySelector('body').offsetHeight*0.1 && !showing) {
		    	showing = true;
		        $('#whatsapp-icon').stop(true, true).fadeIn(600);
		    }else if($(this).scrollTop() < document.querySelector('body').offsetHeight*0.1 && showing) {
		    	showing = false;
		        $('#whatsapp-icon').stop(true, true).fadeOut(600);
		    }
		});
	}
}
hoculus.discountBtns = function(){
	var btns = document.querySelectorAll('[data-hoculus-discount]');
	if (btns.length>0){
		btns.forEach(function(e,i){
			$(e).on('click',function(){
				var button = $(e);
				button.off();
				hoculus.utils.lockWidth(button);
				button.toggleClass('disabled btn--loading');
	    		hoculus.utils.addDiscount(e.dataset.hoculusDiscount).then(function(resp){
	    			button.toggleClass('btn--loading');
	    			switch(Shopify.locale){
	    				case 'en':
	    				button.text('✅ Added');
	    				break;
	    				default:
	    				button.text('✅ Aggiunto');
	    			}
	    			hoculus.utils.analyticsEvent('Hero discount','click','added - '+e.dataset.hoculusDiscount);
	    			setTimeout(function(){
	    				hoculus.discountBanners();
	    			},100)
	    		});
			})
		})
	}
}
if (window.location.pathname != '/password'){
	hoculus.domready(hoculus.utils.onLoad);
}else{
	hoculus.domready(function(){
	    hoculus.addCalendar();
	    hoculus.countDown();
	    hoculus.klaviyoFireEvent();
	});
}
hoculus.last_Y =  document.documentElement.clientWidth;
hoculus.resize(function(){
    //Vertical only
    if ((document.documentElement.clientWidth - hoculus.last_Y)!=0){
    	hoculus.lazyVideo();
        hoculus.last_Y = document.documentElement.clientWidth;
    }
});